module.exports = __webpack_public_path__ + "img/hands-and-gestures.c6f0dc81.svg";